import { SINGLETON_KEY } from '#layers/base/public';
import { defineWorkspaceHydration } from '#layers/runtime/public';

/** The settings singleton of a workspace runtime. */
export const workspaceSettingsHydration = defineWorkspaceHydration((store) => store.MonospaceSettings.query((q) => q.first({ key: SINGLETON_KEY })), { empty: null });
